export const REDUCER_NAME = 'voucher'



// WEBPACK FOOTER //
// ./src/modules/voucher/state/const.js